import { render, staticRenderFns } from "./GitConfigImporter.vue?vue&type=template&id=0fe51e2f&scoped=true"
import script from "./GitConfigImporter.vue?vue&type=script&lang=js"
export * from "./GitConfigImporter.vue?vue&type=script&lang=js"
import style0 from "./GitConfigImporter.vue?vue&type=style&index=0&id=0fe51e2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe51e2f",
  null
  
)

export default component.exports